import classNames from "classnames";
import { AirportSidePanel } from "components/SidePanel/Airport/AirportSidePanel";
import React from "react";

interface Props {
  selected: boolean
  hovered: boolean
  airport: server.dto.Airport
  onOpen: () => void
  onHover: (airport: server.dto.Airport) => void
}

export const AirportForMap = ({ selected, hovered, airport, onOpen, onHover }: Props) => {

  const classes = classNames("hoverable gray-100 planning-map-venue-item-content", {
    "planning-map-item-content-selected": selected,
    "planning-map-item-content-hovered": hovered && !selected,
  });

  return <AirportSidePanel
    onOpen={onOpen}
    airportId={airport.airportId}
    trigger={<div className={classes}
      onMouseEnter={() => onHover(airport)}
      onMouseLeave={() => onHover(undefined)}>
      <div className="grow1">
        <div className="text-ellipsis subtitle-text-medium">{airport.name}</div>
        <div className="text-ellipsis body-text-regular">{airport.iata}</div>
        <div className="text-ellipsis body-text-regular s1_gray">{airport.location}</div>
      </div>
    </div>}
  />
};
